import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 1 1v8a6 6 0 1 1 -12 0v-8a1 1 0 0 1 1 -1h1v-4a1 1 0 0 1 1 -1zm-1 2h-4v3h4z","key":"svg-0"}]]

const IconDeviceUsbFilled = createReactComponent('filled', 'device-usb-filled', 'DeviceUsbFilled', __iconNode);

export default IconDeviceUsbFilled;